import { keyframes } from 'styled-components/macro';

export const slideArrowIn = keyframes`
  from {
    transform: translateX(0px);
  } to {
    transform: translateX(5px);
  }
`;

export const slideArrowOut = keyframes`
  from {
    transform: translateX(5px);
  } to {
    transform: translateX(0px);
  }
`;

export const slideTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-40%);
  } to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const slideBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  } to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const slideRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(25%);
  } to {
    opacity: 1;
    transform: translateX(0%);
  }
`;

export const slideRightExit = keyframes`
  from {
    opacity: 1;
    transform: translateX(0%);
  } to {
    opacity: 0;
    transform: translateX(25%);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  } to {
    opacity: 0;
  }
`;

export const slideLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-10%);
  } to {
    opacity: 1;
    transform: translateX(0%);
  }
`;

export const open = keyframes`
  from {
    max-height: 200px;
  } to {
    max-height: 1000px;
  }
`;

export const fakeTicket = keyframes`
  from {
    background-position: 200% 0;
   } to {
    background-position: 0 0;
  }
`;
